import React from 'react';
import { authRoles } from 'src/app/auth';

const Managers = React.lazy(() => import('./Managers'));
const NewManager = React.lazy(() => import('./new-manager/NewManager'));

const ManagersConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  auth: authRoles.admin,

  routes: [
    {
      path: 'managers',
      element: <Managers />,
      auth: null,
    },
    {
      path: 'managers/new',
      element: <NewManager />,
      auth: null,
    },
    {
      path: 'managers/edit/:id',
      element: <NewManager />,
      auth: null,
    },
  ],
};

export default ManagersConfig;
